import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { LeadService } from '@http/clients/reporting-app/lead.service';
import { GenericDropdownMultiselectComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-opportunity-source-form-editor',
    templateUrl: './report-opportunity-source-form-editor.component.html',
    styleUrls: ['./report-opportunity-source-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportOpportunitySourceFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownMultiselectComponent]
})
export class ReportOpportunitySourceFormEditorComponent extends FormEditorBase<number[] | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Opportunity Source');
    placeholderText = input<string>('Select Opportunity Source');

    private readonly leadService = inject(LeadService);

    async ngOnInit(): Promise<void> {
        const leads = await this.leadService.getAll();
        this.items.set(leads);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number[] | null {
        const selected = this.selectedItems() ?? [];
        if (!selected.length) return null;
        return selected.map((item) => Number(item.id));
    }

    protected override mapValueToSelectedItems(value: number[] | null): any[] {
        if (!value?.length) return [];
        const selectedIds = new Set(value.map((id) => Number(id)));
        return (this.items() ?? []).filter((item) => selectedIds.has(Number(item.id)));
    }
}
